// A tiny buffer for analytics emitted before PostHog exists.
//
// `bootstrapMiniapp` deliberately runs *before* `root.render()` so the session
// is settled before anything paints — but PostHog is initialised by
// <PostHogProvider> during that render. So every capture()/register() made from
// bootstrap was being dropped on the floor: no `miniapp_launch` at all, and
// `miniapp_platform` empty on every later event, which is exactly the
// visibility we needed to diagnose a platform-specific failure.
//
// Queue during bootstrap, flush once the provider has mounted.

import posthog from 'posthog-js'

type Props = Record<string, unknown>

let superProps: Props = {}
let queued: Array<{ name: string; props: Props }> = []
let flushed = false

/** Super-properties to attach to every later event. */
export const queueRegister = (props: Props) => {
    superProps = { ...superProps, ...props }
    if (flushed) posthog.register(props)
}

export const queueEvent = (name: string, props: Props = {}) => {
    if (flushed) {
        posthog.capture(name, props)
        return
    }
    queued.push({ name, props })
}

/** Called once PostHog is live. Safe to call more than once. */
export const flushTelemetry = () => {
    if (flushed) return
    flushed = true
    if (Object.keys(superProps).length) posthog.register(superProps)
    queued.forEach(({ name, props }) => posthog.capture(name, props))
    queued = []
}
